import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useEffectEvent,
  useState,
} from "react";

interface IEnvJSON {
  APP_ENV: string;
  GA_KEY: string;
  RECAPTCHA_KEY: string;
}
interface IEnvContext {
  envJSON: IEnvJSON | null;
  isLoadingEnv: boolean;
}

interface IEnvJSONProvider {
  children: ReactNode;
}

export const EnvContext = createContext<IEnvContext | undefined>(undefined);

export const EnvJSONProvider = ({ children }: IEnvJSONProvider): ReactNode => {
  const [envJSON, setEnvJSON] = useState<IEnvJSON | null>(null);
  const [isLoadingEnv, setIsLoadingEnv] = useState<boolean>(true);

  const loadEnv = useEffectEvent(async (): Promise<void> => {
    const res = await fetch("/env.json");
    if (!res.ok) throw new Error("Failed to load env.json");
    const envData = await res.json();
    setEnvJSON(envData);
    setIsLoadingEnv(false);
  });

  useEffect(() => {
    if (!envJSON) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      loadEnv();
    }
  }, [envJSON]);

  return (
    <EnvContext.Provider value={{ envJSON, isLoadingEnv: isLoadingEnv }}>
      {children}
    </EnvContext.Provider>
  );
};

export const useEnvJSON = (): IEnvContext => {
  const context = useContext(EnvContext);
  if (context === undefined) {
    throw new Error("'useEnvJSON' must be used within a 'EnvJSONProvider'.");
  }

  return context;
};
